import { forwardRef } from 'react';
import { Link } from 'react-router-dom';

// Helper to forward the ref to react-router's Link
const RouterLink = forwardRef((props, ref) => {
  return <Link {...props} ref={ref} />;
});

export default RouterLink;
